import React, { useState, useEffect, useContext, useRef } from "react";
import { CurrentUserContext } from '../../../context/CurrentUserContext.js';
import { useParams, useNavigate } from "react-router-dom";
import { courseRegistry } from "../../../courses/courseRegistry.js";
import { videoBaseUrl } from "../LevelContentData";
import { videoTitle } from "../../../utils/titles.js";
import { slugify, slugToText } from "../../../utils/slugify";
import { slugAlias } from "../../../utils/slugAlias.js";
import "./VideosHome.css"; 
import "../MyNotes/FundamentalsMyNotes.css";
import { Link } from "react-router-dom" ;
import VideoPlayer from "../../VideoPlayer/VideoPlayer";
import {countryToLang } from "../../../utils/languageMap.js";
import { useTranslation } from "../../../utils/hooks/translateHook.js";  
import { useLevelContentData } from "../../../utils/hooks/translateLevelContentDataHook.js";
import { transformLevelContent } from "../../../utils/transformLevelContent.js";
import fundamentals from "../config.js";
import { hasAccess } from "../../../utils/permissions.js";
import { getCourseProgress } from "../../../utils/API/progressApi.js";
import downloadIcon from "../../../images/icons/download.svg";
import viewIcon from "../../../images/icons/viewIcon.svg";
import videoArrow from "../../../images/icons/videoArrow.svg"


export const API_URL = window.location.hostname === "localhost"
  ? "http://localhost:4000/api"
  : process.env.REACT_APP_API_URL //"http://academy-backend-env.eba-qassrxas.eu-north-1.elasticbeanstalk.com/api";

const CLOUDFRONT_DOMAIN = "vixacademy.com/videos"  //"d2ytlht1oeujr4.cloudfront.net";
 //Creates mini ID's global so 1.1.2  or 1.1.4 etc finds the translation
  const extractPrefix = (str) => {  //used by UI - lecture link hls fix as well besides the level check for the users
    const match = str.match(/^(\d+)[.-](\d+)[.-](\d+)/);
    return match ? `${match[1]}.${match[2]}.${match[3]}` : null;
  };
    //Slugify Link and UI BUGFIX >> main  Helper function 
  const buildVideoPrefixMap = (levels = []) => {
    const map = {};

    levels.forEach(level => {
      (level.subjects || []).forEach(subject => {
        (subject.videos || []).forEach(video => {
          const prefix = extractPrefix(video);
          if (prefix) map[prefix] = video;
        });
      });

      (level.videos || []).forEach(group => {
        (group.list || []).forEach(video => {
          const prefix = extractPrefix(video);
          if (prefix) map[prefix] = video;
        });
      });
    });

    return map;
  };


const VideosHome = ({ user, subject }) => {
  const {currentUser , notesUpdated, setNotesUpdated} = useContext(CurrentUserContext);
  const [currentProgress, setCurrentProgress] = useState(null);
  const [openSubjectIndex, setOpenSubjectIndex] = useState(null);
  const [note, setNote] = useState("");
  const [loadedVideoDuration, setLoadedVideoDuration] = useState(0);
  const [signedVideoUrl, setSignedVideoUrl] = useState(null);
  const saveTimeout = useRef(null);
  const t = useTranslation();
  const translatedData = useLevelContentData (fundamentals.levelContentData, fundamentals.slug)
  const transformedData = transformLevelContent(translatedData)
  const navigate = useNavigate(); 
  const { videoSlug, courseSlug } = useParams();
  const accessibleLevels = transformedData
  .filter(item => hasAccess(user, item.level, courseSlug) && item.level !== 9999)
  .sort((a, b) => a.level - b.level);

  const courseConfig = courseRegistry[courseSlug];
  const realSlug = slugAlias[videoSlug] || videoSlug; 
  const realPrefix = realSlug?.split("-").slice(0, 3).join(".");
  const userCourse = user?.courses?.find((course) => course.courseSlug === courseSlug && course.status === "active");
  const userLevel = user?.subscriptionLevel === 9999 
    ? 9999
    : Number(userCourse?.level || 0 );

  const [lang2Letter, setLang2Letter] = useState("en");
  const getLangByCountry = (countryValue) => {
    if (!countryValue) return "en";
    return countryToLang[countryValue.toUpperCase()] || "en";
  };    
  

  useEffect(() => {
    if (user?.country) {
      const code = user.country.toUpperCase()
      const defaultLang = getLangByCountry(code);
      console.log("🌎 Country:", user.country, "→ Default lang:", defaultLang);
      setLang2Letter(defaultLang);
    }
  }, [user?.country]);


//the useEffect that provides order for the level of the users
useEffect(() => {
  if (!realSlug || !courseSlug || !userLevel || !transformedData.length) {
    return;
  }
  const slugPrefix = realSlug.split("-").slice(0, 3).join(".");
  let requiredLevel = null;

  // Flatten all videos into a list
  const allVideos = transformedData.flatMap(level =>
    (level.videos || []).flatMap(group =>
      (group.list || []).map(video => ({
        level: level.level,
        title: typeof video === "string" ? video : video.title
      }))
    )
  );

  // Find matching video by prefix
  const matched = allVideos.find(video => {
    const videoPrefix = extractPrefix(video.title);
    return videoPrefix && videoPrefix === slugPrefix;
  });

  if (matched) {
    requiredLevel = matched.level;
    console.log(`✅ Match found ➤ Title: ${matched.title} | Level: ${requiredLevel}`);
  }

  console.log("🎯 Matched video:", matched?.title || "none", "| Required level:", requiredLevel, "| User level:", userLevel);

  if (requiredLevel && userLevel < requiredLevel) {
    console.warn("🚫 Access denied: video beyond user level");
    navigate("/upgrade");
  }
}, [navigate, videoSlug, realSlug, courseSlug, userLevel, transformedData]);

//Completion  Progress useEffect
useEffect(() => {
  if (!courseSlug || !videoSlug) return;

  getCourseProgress(courseSlug)
    .then(({ courseProgress}) => {
      const thisVideo = courseProgress.progress?.find(
        item => item.lessonSlug === realSlug || item.lessonSlug === videoSlug 
      );
         console.log("THIS VIDEO PROGRESS:", thisVideo);
      setCurrentProgress(thisVideo || null); 
    })
    .catch(() => setCurrentProgress(null));
}, [courseSlug, videoSlug, realSlug]);



  useEffect(() => {
    console.log("running useEffect for video URL setup", realSlug, currentUser);
    if (!realSlug || !currentUser) return;
    const isLocal = window.location.hostname === "localhost";
    const fallbackUrl = `${videoBaseUrl}${realSlug}/master.m3u8`;
    if (isLocal) {
      //console.log("Localhost detected → Using offline video:", fallbackUrl);
      setSignedVideoUrl(fallbackUrl);
      return;
    }
    fetch(`${API_URL}/video-url/${courseSlug}/${realSlug}?_=${Date.now()}`, {  // Only run this fetch if NOT localhost
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      credentials: "include",
    })
      .then((res) => {
          if (res.status === 403) {
            navigate("/upgrade");
            return Promise.reject("Access denied");
          }
          if (!res.ok) {
            return Promise.reject("Request failed");
          }
          return res.json();
        })
      .then((data) => {
        const cloudUrl = `https://${CLOUDFRONT_DOMAIN}/${realSlug}/master.m3u8`;
        const finalUrl = data.signedUrl || cloudUrl;      //data.signedUrl  will be undefined/null if not allowed also starts null then gets the url-good for singular files 
        //console.log("✅ Using signed or fallback cloud URL:", finalUrl);
        setSignedVideoUrl(finalUrl);
      })
      .catch((err) => {
        //console.warn("⚠️ Fetch error → fallback to local video:", fallbackUrl);
        setSignedVideoUrl(fallbackUrl);
      });
  }, [navigate, realSlug, currentUser]);

  /*   const videoUrl = `${API_URL}/video-url/${realSlug}`; */   
  //for showing present notes
  useEffect(() => {
    if (!realSlug || !user) return;

    fetch(`${API_URL}/notes/${courseSlug}/${realSlug}?_=${Date.now()}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("No note found");
        return res.json();
      })
      .then((data) => {
        if (data && data.content) {
          setNote(data.content);
        } else {
          setNote("");
        }
      })
      .catch((err) => {
        console.log("An Error Occured:", err)
      });
  }, [realSlug, courseSlug ,user, notesUpdated]);

  // useEffect(() => {
  //   if (!note || !realSlug || !user) return;
  //   clearTimeout(saveTimeout.current);

  //   saveTimeout.current = setTimeout(() => {
  //     fetch(`${API_URL}/notes/${courseSlug}/${realSlug}?_=${Date.now()}`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${localStorage.getItem("token")}`
  //       },
  //       body: JSON.stringify({ content: note })
  //     }).then(res => {
  //       if (res.ok) {
  //         console.log("💾 Auto-saved");
  //         setNotesUpdated(prev => prev + 1);
  //       }
  //     }).catch(console.error);
  //   }, 25000); 
  // }, [note, realSlug, courseSlug, user, setNotesUpdated]);

  const handleSaveNote = () => {
    fetch(`${API_URL}/notes/${courseSlug}/${realSlug}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ content: note })
    })
    .then(res => res.json())
    .then(() => {
      setNotesUpdated(prev => prev +1);  
      alert('Note saved!');
    });
  };

  useEffect(() => {
    if (!videoSlug && courseConfig) {
      if (window.innerWidth < 1340) {
        navigate( `/course/${courseSlug}/videosTree`, { replace: true });
        return;
      }
      const firstLevelWithVideos =
        courseConfig.levelContentData.find(
          (level) => Array.isArray(level.videos) && level.videos.length > 0
        );
      const firstVideo = firstLevelWithVideos?.videos?.[0]?.list?.[0];
      if (firstVideo) {
        navigate( `/course/${courseSlug}/videos/${slugify(firstVideo)}`, { replace: true });
      }
    }
  }, [ videoSlug, courseSlug, courseConfig, navigate]);

  const handleDownloadNote = () => {
    const element = document.createElement("a");
    const file = new Blob([note], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = `${slugToText(videoSlug)}-note.txt`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  //left menu and links fix after UI translations
  const englishVideoByPrefix = React.useMemo(() => {
    return buildVideoPrefixMap(courseConfig?.levelContentData || []);
  }, [courseConfig]);
  const translatedVideoByPrefix = React.useMemo(() => {  // notes kisminda kullaniyoruz displayTitle parametresi ile
    return buildVideoPrefixMap(transformedData || []);
  }, [transformedData]);
  const displayTitle =
    translatedVideoByPrefix[realPrefix] ||   slugToText(realSlug);
  //console.log("accesibledata", accessibleLevels)

  const progressPercent = Math.min( 100, Math.max (0, Number( currentProgress?.watchedPercent ??
        (currentProgress?.videoDuration > 0 ? (currentProgress.watchedSeconds / currentProgress.videoDuration) * 100 : 0 )
      )
    )
  );
  const savedDuration = Number(currentProgress?.videoDuration);
  const playerDuration = Number(loadedVideoDuration);
  const videoDuration = Number.isFinite(savedDuration) && savedDuration > 0 
                        ? savedDuration: Number.isFinite(playerDuration) && playerDuration > 0 ? playerDuration : 0;
  const savedWatchedSeconds = Number(currentProgress?.watchedSeconds);
  const watchedSeconds = Number.isFinite(savedWatchedSeconds) && savedWatchedSeconds > 0 ? savedWatchedSeconds : 0;
  const remainingSeconds = videoDuration > 0 ? Math.max(0, videoDuration - watchedSeconds) : 0;
  const formatDuration = (totalSeconds) => {
    const numericSeconds = Number(totalSeconds);
    if (!Number.isFinite(numericSeconds) || numericSeconds < 0) { return ""; }
    const seconds = Math.floor(numericSeconds);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSecs = seconds % 60;
    if (hours > 0) {
      return `${hours} hr ${minutes} min ${remainingSecs} sec`;
    }
    return `${minutes} minutes ${remainingSecs} sec`;
  };

  const formatLastVisited = (dateValue) => {
    if (!dateValue) return "Not visited yet";
    return new Date(dateValue).toLocaleString("en-GB", {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  };

  const handleVideoProgress = async ({watchedSeconds, videoDuration }) => {
    const safeDuration = Number(videoDuration) || 0;
    const safeWatchedSeconds = Number(watchedSeconds) || 0;
    const watchedPercent = safeDuration > 0 ? Math.min( 100, Math.round((safeWatchedSeconds / safeDuration) * 100)): 0;
    const status = watchedPercent >= 95  ? "completed" : watchedPercent > 0 ? "played" : "not started";

    setCurrentProgress((previous) => ({
      ...previous,
      watchedSeconds: safeWatchedSeconds,
      videoDuration: safeDuration,
      watchedPercent,
      status,
      lastVisitedAt: new Date().toISOString(),
    }));

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/progress`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          courseSlug,
          lessonSlug: realSlug,
          lessonType: "video",
          title: videoTitle(displayTitle)
            .replace(/^(\d+)\s(\d+)\s(\d+)/, "$1.$2.$3"),
          watchedSeconds: safeWatchedSeconds,
          videoDuration: safeDuration,
        }),
      });

      if (!response.ok) {
        throw new Error(`Progress save failed: ${response.status}`);
      }

      const data = await response.json();
      const savedProgress = data?.progress || data;
      if (
        savedProgress &&
        typeof savedProgress === "object"
      ) {
        setCurrentProgress((previous) => ({
          ...previous,
          ...savedProgress,
        }));
      }
    } catch (error) {
      console.error("Video Progress Error:", error);
    }
  };

  return (
    <div className="layout-v">
      <div className="video-page">
        <div className="video-content">
          <aside className="sidebar">
            <h3 className="video-sidebar-title">
              <span>{t("video_courses").toUpperCase()}</span>
              <img src={videoArrow} alt="" className="video-sidebar-arrow"/>
            </h3>
            <div className="map-container video-sidebar">
              {accessibleLevels.flatMap(level => level.subjects || []).map((subject, idx) => (
                <details key={idx} className="subject-accordion video"
                  open={openSubjectIndex === idx}
                >
                  <summary className="videoSubject-title"
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenSubjectIndex(openSubjectIndex === idx ? null : idx);
                    }}
                  >
                    {(subject.title).toUpperCase()}
                  </summary>

                  {Array.isArray(subject.videos) && subject.videos.length > 0 && (
                    <ul className="video-list">
                      {subject.videos.map((filename, vidIdx) => {
                        const prefix = extractPrefix(filename);
                        const englishTitle = englishVideoByPrefix[prefix] || filename;
                        const canonicalSlug = slugify(englishTitle);
                        return (
                          <li key={vidIdx}>
                            <Link to={`/course/${courseSlug}/videos/${canonicalSlug}`}>
                              {videoTitle(filename)
                                .replace(/^\d+(\.\d+)*\.\s*/, '')
                                .toUpperCase()}
                            </Link>
                          </li>
                        );

                      })}
                    </ul>
                  )}
                </details>
              ))}
            </div>
          </aside>

          {/* Main Content */}
          <main className="video-main">
            <div className="video-mobile-bar">
              <span className="video-mobile-link"
                onClick={() => navigate(`/course/${courseSlug}/videosTree`)}
              > {t("video_courses").toUpperCase()}
              </span>
              <span className="video-mobile-divider"> |</span>
              <span className="video-mobile-current">
                {videoTitle(displayTitle)
                  .replace( /^(\d+)\s(\d+)\s(\d+)/, "$1.$2.$3")
                  .toUpperCase()}
              </span>
            </div>
            {user && videoSlug && signedVideoUrl && (
              <div className="video-box">
                <VideoPlayer
                  videoUrl={signedVideoUrl} 
                  country={user?.country}    
                  lang={lang2Letter} 
                  onProgress={handleVideoProgress}   
                  onDurationLoaded={setLoadedVideoDuration} 
                />
              </div>
            )}

            <div className="video-progress-card">
                <div className="video-progress-details">
                  <div className="video-progress-area">
                    <div className="video-progress-track">
                      <div className="video-progress-fill" style={{ width: `${progressPercent}%` }}/>
                        <div className="video-progress-labels">
                          <span className={`video-progress-status ${progressPercent === 0 ? "is-not-started" : ""}`}>
                            {progressPercent >= 95 ? "completed" : progressPercent > 0 ? "played": "not started"}
                          </span>
                          <span className="video-progress-remaining">
                            {videoDuration > 0 ? `${formatDuration(remainingSeconds)} left` : "Loading duration..."}
                          </span>
                        </div>
                        <span className="video-progress-percent" style={{ left: `${progressPercent}%` }}>
                          {Math.round(progressPercent)}%
                        </span>
                    </div>
                  </div>
                  <div className="video-progress-visited">
                    last visited: {formatLastVisited(currentProgress?.lastVisitedAt)}
                  </div>
                </div>
             
            </div>

            <div className="notes-section-f">
              <div className="notes-header-f">
                <p className="lesson-title-video-f">
                  <strong>{t('lessonName')} </strong>
                  {videoTitle(displayTitle)
                    .replace(/^(\d+)\s(\d+)\s(\d+)/, '$1.$2.$3')
                    .toUpperCase()}
                </p>
                <div className="note-buttons-create">
                  <button className="icon-button-nots" onClick={handleSaveNote} title="Save">
                    <div className="icon"style={{ "--icon": `url(${viewIcon})` }}/>
                  </button>
                  <button className="icon-button-nots" onClick={handleDownloadNote} title="Download">
                    <div className="icon" style={{ "--icon": `url(${downloadIcon})` }}/>
                  </button>
                </div>
              </div>
              <textarea className="note-input"  
                placeholder="Write your notes here..."
                value={note} 
                onChange={(e) => setNote(e.target.value)}
              />
            </div>
        </main>
        </div>
      </div>
    </div>
  );
};

export default VideosHome;
